import { t } from "i18next";
import React, { useEffect } from "react";
import { Button } from "../Button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../Command";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover";
import { ScrollArea } from "../ScrollArea/ScrollArea";

type SelectOption = {
  value: string;
  label: string;
};

interface SelectButtonProps {
  label?: string;
  searchable?: boolean;
  options: SelectOption[] | null;
  value: SelectOption | null;
  onChange: (item: SelectOption | null) => void;
  disabled?: boolean
}

export function SelectButton({ options, value, searchable = false, onChange, label, disabled = false }: SelectButtonProps) {
  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState<SelectOption | null>(value ? value : null);

  // Сброс значения при value = null/undefined
  useEffect(() => {
    if (!value) setSelected(null);
  }, [value]);

  function handleChange(value: SelectOption | null) {
    setSelected(value);
    onChange(value);
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          disabled={disabled}
          variant="outline"
          className="w-full justify-start data-[state=open]:border-primary data-[state=open]:border-2"
        >
          {selected ? <>{selected?.label}</> : <>{label}</>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popper-anchor-width)] p-0 " align="start">
        <List searchable={searchable} options={options} setOpen={setOpen} setSelected={(item) => handleChange(item)} />
      </PopoverContent>
    </Popover>
  );
}

function List({
  searchable,
  options,
  setOpen,
  setSelected,
}: {
  searchable?: boolean;
  options: SelectOption[] | null;
  setOpen: (open: boolean) => void;
  setSelected: (item: SelectOption | null) => void;
}) {
  const [search, setSearch] = React.useState("");
  const handleSearch = (input: any) => {
    setSearch(input);
  };

  let filteredOptions = options?.filter((item) => {
    return item.label.toLowerCase().includes(search.toLowerCase());
  });

  function handleSelect(value: string) {
    setSelected(
      filteredOptions?.find((priority) => priority.value === value) || null
    );
    setOpen(false);
  }

  return (
    <Command shouldFilter={false}>
      {searchable && <CommandInput value={search} onValueChange={handleSearch} placeholder={t("search")} />}
      {/* <ScrollArea className="h-[200px] w-full overflow-hidden"> */}
        <CommandList className="h-full">
          <CommandEmpty>No results found.</CommandEmpty>
          <CommandGroup>
            {filteredOptions?.map((option) => (
              <CommandItem key={option.value} value={option.value} onSelect={(value) => handleSelect(value)}>
                {option.label}
              </CommandItem>
            ))}
          </CommandGroup>
        </CommandList>
      {/* </ScrollArea> */}
    </Command>
  );
}
